import { getDataWithPromise, handleAjaxError} from "./BaseDataFns";

export const getSchoolConcernReports = (school_id, onCompleteFunc) => {

  const url =  Globals.APIFolder + '/school/' + school_id + '/concern-report' ;

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
  .catch((jqXHR, textStatus, error) =>
  {
    handleAjaxError(jqXHR, textStatus, error);
  });

  return ;
};

export const getActiveConcernReportsForSChool = (school_id, onCompleteFunc) => {

  const url =  Globals.APIFolder + '/school/' + school_id + '/concern-report?status=active' ;

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

export const getActiveConcernReportsForSchoolPromise = (school_id) =>
{
  const url =  Globals.APIFolder + '/school/' + school_id + '/concern-report?status=active' ;

  return getDataWithPromise(url, 'GET', {});
}

export const getConcernReportDetails = (cr_id, onCompleteFunc) => {

  const url =  Globals.APIFolder + '/concern-report/' + cr_id ;

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

export const createConcernReport = (formData, action, onCompleteFunc) => {

  const url = Globals.APIFolder + '/concern-report?action=' + action;

  getDataWithPromise(url, 'POST', {formData}).then(data =>
  {
    onCompleteFunc(data);
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return;
};


export const updateConcernReport = (cr_id, action, formData, onCompleteFunc) => {

  const url = Globals.APIFolder + '/concern-report/' + cr_id + '?action=' + action;

  getDataWithPromise(url, 'PUT', {formData}).then(data =>
  {
    onCompleteFunc(data);
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return;
};
